import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { LoadingButton } from 'src/components/buttons/LoadingButton';
import Typography from '@mui/material/Typography';
import { GradientTypography } from 'src/components/gradients/GradientTypography';
import Box from '@mui/material/Box';
import {
  WizardElementProps,
  withoutWizardProps,
} from 'src/components/wizard/Wizard';
import { CheckInStore } from './useCheckInDialog';
import { useState } from 'react';
import { useAuth } from 'src/contexts/AuthContext';
import { useCheckIn } from 'src/components/tournaments/check-in/CheckInContext';

export const UnregisterGuardDialog = withoutWizardProps(
  ({ go }: WizardElementProps<CheckInStore>) => {
    const [error, setError] = useState(false);

    const { gameId, tournamentId, teamId } = useCheckIn();
    const { user } = useAuth();
    const unregister = async () => {
      try {
        setError(false);
        if (!user) {
          throw new Error();
        }
        const { exitTeam } = await import(
          '../../../firebaseCloud/tournament/exitTeam'
        );
        await exitTeam({
          gameId,
          userId: user.uid,
          tournamentId,
          teamId,
        });
        go('UnregisteredDialog');
      } catch (e) {
        setError(true);
        console.error(e);
      }
    };

    return (
      <>
        <DialogTitle sx={{ color: 'black', textAlign: 'center' }}>
          <GradientTypography
            gradientColor="primary.vertical"
            variant="h4"
            sx={{ textTransform: 'uppercase' }}
          >
            Are You Sure?
          </GradientTypography>
        </DialogTitle>
        <DialogContent sx={{ overflow: 'hidden', backgroundImage: 'none' }}>
          <Typography variant="h6">
            This will remove you from the tournament. <br /> You will NOT be
            able to re-register.
          </Typography>
          {error && (
            <Typography variant="h6" color="error">
              There was an error while trying to unregister.
            </Typography>
          )}
        </DialogContent>
        <DialogActions
          sx={{
            mt: 4,
            px: 0,
            pb: 0,
            width: '100%',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
              gap: 4,
            }}
          >
            <LoadingButton
              variant="contained"
              color="error"
              size="large"
              onClick={unregister}
              sx={{ flex: 1, width: '100%' }}
            >
              Unregister
            </LoadingButton>
            <Button
              variant="contained"
              color="primary"
              size="large"
              onClick={() => {
                return go('EntryDialog');
              }}
              sx={{ flex: 1, width: '100%' }}
            >
              Back
            </Button>
          </Box>
        </DialogActions>
      </>
    );
  },
);
